var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"leaderboard"},[_c('img',{attrs:{"alt":"Safety In Focus","src":require("@/assets/SIP_logo_XL.png")}}),_c('TopPlayers',{attrs:{"records":_vm.playerScores}}),_c('TopRegional',{attrs:{"records":_vm.regionalScores}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }